import React from 'react';
import { Helmet } from 'react-helmet-async';

const CANONICAL_URL = 'https://softwaredeveloperindia.com';

const SEO = ({ 
  title = "Software Developer India | Custom Software Development Company",
  description = "Leading software development company in India. We build custom enterprise software, SaaS products, web & mobile applications. 200+ successful projects, 15+ industries served. Get free consultation!",
  keywords = "software development India, custom software development, enterprise software, SaaS development, mobile app development, web development, software company India, Bangalore software developers",
  author = "Software Developer India",
  ogImage = "https://softwaredeveloperindia.com/assets/images/python-software-development.png",
  ogUrl = CANONICAL_URL + '/',
  twitterImage = "https://softwaredeveloperindia.com/assets/images/python-software-development.png"
}) => {
  return (
    <Helmet>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link href="https://fonts.googleapis.com/css2?family=Saira+Stencil:wght@300;400;500;600;700;800;900&display=swap" rel="stylesheet" />
      
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      
      {/* Google Site Verification */}
      <meta name="google-site-verification" content="EnaGlaUP-kb_6So3l8EiDgxjJt9UtKsymNgMLwP3IRc" />
      
      {/* Google tag (gtag.js) */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-2JS8D3PSK2"></script>
      <script>
        {`window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-2JS8D3PSK2');`}
      </script>
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={ogUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={ogUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={twitterImage} />
      
      {/* Canonical URL - always points to non-www HTTPS version */}
      <link rel="canonical" href={ogUrl} />
      <meta property="og:site_name" content="Software Developer India" />
    </Helmet>
  );
};

export default SEO;
